import api from './api'

export async function listModel3dLayers() {
  const { data } = await api.get('/models3d')
  // Le serveur enveloppe la liste (Controller/model3dController.js:395,
  // `res.json({ layers: [...] })`) — le deballer ici, pas chez l appelant.
  return data?.layers ?? []
}

export async function initiateModel3dUpload(payload) {
  const { data } = await api.post('/models3d/uploads/initiate', payload)
  return data
}

export async function finalizeModel3dUpload(id, body) {
  const { data } = await api.post(`/models3d/uploads/${id}/finalize`, body)
  return data
}

export async function abortModel3dUpload(id) {
  const { data } = await api.post(`/models3d/uploads/${id}/abort`)
  return data
}

export async function deleteModel3dLayer(id) {
  const { data } = await api.delete(`/models3d/${id}`)
  return data
}

// Base du backend = VITE_URL (la MEME que l instance axios `api`, qui inclut deja
// /api) — PAS VITE_API_URL, absente en dev (cf operationalLayerApi.js). deck.gl/
// loaders.gl fetchent hors axios, donc il faut une URL absolue, pas un chemin relatif.
const TILE_API_BASE = (
  import.meta.env.VITE_URL || 'https://data.eldatechnology.fr/api'
).replace(/\/$/, '')

export const model3dTilesetUrl = layerId =>
  `${TILE_API_BASE}/models3d/${layerId}/tiles/tileset.json`
